import {Dispatch} from 'redux';
import {DATETABS_SELECT_TAB} from 'store/actionTypes';
import {DateTabsSelectIndexAction} from '../types';

// TODO: documentation

const setSelectedDateTab = (index: number) => (
  dispatch: Dispatch<DateTabsSelectIndexAction>,
): void => {
  dispatch({
    type: DATETABS_SELECT_TAB,
    payload: {selectedIndex: index},
  });
};

export default setSelectedDateTab;
